/**
 * Localized relative-time for a tool's last-used timestamp.
 *
 * Mid-sentence numbers stay interpolated via i18next `{{count}}` plural
 * (`_one`/`_other`) — the unit keys live in the `dashboardTools.*` namespace.
 */
import type { TFunction } from 'i18next'

const MIN = 60_000
const HOUR = 60 * MIN
const DAY = 24 * HOUR

export function toolUsageRelativeTime(iso: string | null, t: TFunction): string | null {
  if (!iso) return null
  const diff = Date.now() - new Date(iso).getTime()
  if (Number.isNaN(diff)) return null
  if (diff < MIN) return t('dashboardTools.relative.now')
  if (diff < HOUR) {
    const count = Math.floor(diff / MIN)
    return t('dashboardTools.relative.minutes', { count })
  }
  if (diff < DAY) {
    const count = Math.floor(diff / HOUR)
    return t('dashboardTools.relative.hours', { count })
  }
  const count = Math.floor(diff / DAY)
  return t('dashboardTools.relative.days', { count })
}
